<template>
    <div class="w-full pb-8">
        <div class="flex w-full items-center">
            <template v-for="(step, index) in steps" :key="index">
                <!-- Dot: only content in flex flow so mx-5 gap is from dot edge, not label edge -->
                <div :class="step.status === 'active' ? 'h-4 w-4' : 'h-3 w-3'" class="relative shrink-0">
                    <spinner v-if="step.loading" class="absolute inset-0" />
                    <div
                        v-else
                        :class="[step.status === 'active' ? 'h-4 w-4' : 'h-3 w-3', getColor(step, 'bg')]"
                        class="rounded-full transition-all duration-300"
                    />

                    <!-- Label absolutely positioned below dot so it doesn't affect flex sizing -->
                    <div
                        :class="[
                            getColor(step, 'text'),
                            index === 0
                                ? 'left-0 text-left'
                                : index === steps.length - 1
                                  ? 'right-0 text-right'
                                  : 'left-1/2 -translate-x-1/2 text-center',
                        ]"
                        class="absolute top-full mt-1 text-sm font-medium whitespace-nowrap transition-colors duration-300"
                    >
                        {{ step.label }}
                    </div>
                </div>

                <!-- Connecting line: mx-5 = 20px from the dot edge -->
                <div v-if="index < steps.length - 1" class="mx-5 h-[1px] flex-1 bg-[#D9D9D9]" />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import Spinner from '@/Components/Spinner.vue';

type ProcessStepStatus = 'open' | 'done' | 'active' | 'succeeded' | 'failed';

type ProcessStep = {
    value: string;
    label: string;
    status: ProcessStepStatus;
    loading?: boolean;
};

defineProps<{
    steps: ProcessStep[];
}>();

const colorMap: Record<ProcessStepStatus, { bg: string; text: string }> = {
    active: { bg: 'bg-primary', text: 'text-primary' },
    done: { bg: 'bg-[#728AC3]', text: 'text-[#728AC3]' },
    failed: { bg: 'bg-danger', text: 'text-danger' },
    succeeded: { bg: 'bg-success', text: 'text-success' },
    open: { bg: 'bg-[#D9D9D9]', text: 'text-[#D9D9D9]' },
};

function getColor(step: ProcessStep, suffix: 'bg' | 'text'): string {
    return colorMap[step.status][suffix];
}
</script>
